import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { DeleteFieldAssessmentsUseCaseInterface } from 'domain/usecases';

export class RemoteDeleteFieldAssessments
  implements DeleteFieldAssessmentsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<DeleteFieldAssessmentsUseCaseInterface.Result>,
  ) {}

  async execute(
    params: DeleteFieldAssessmentsUseCaseInterface.Params,
  ): Promise<DeleteFieldAssessmentsUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'delete',
      url: this.url + '/' + params.id,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
